import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_pairingSetIdAdapter204jlhkjchobz as get_pairingSetIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { KotlinInstantAdapter_instanceecp18tjhxm9b as KotlinInstantAdapter_instance } from '../../../../../../../../apollo-kotlin-adapters-apollo-adapters-core/com/apollographql/adapter/core/KotlinInstantAdapter.mjs';
import { PinnedPairInput_InputAdapter_instance136w4rd1cfalu as PinnedPairInput_InputAdapter_instance } from './PinnedPairInput_InputAdapter.mjs';
import {
  obj2vqjd1bjrpmyg as obj,
  list2lpjhmv1d2k19 as list,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePairAssignmentsInput3tgrc8c2zd524 as SavePairAssignmentsInput } from '../SavePairAssignmentsInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInput_InputAdapterClass;
function SavePairAssignmentsInput_InputAdapter() {
  if (SavePairAssignmentsInput_InputAdapterClass === VOID) {
    class $ {
      p40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      u6x(writer, customScalarAdapters, value) {
        writer.l4d('partyId');
        get_partyIdAdapter().q40(writer, customScalarAdapters, value.q6v_1);
        writer.l4d('pairingSetId');
        get_pairingSetIdAdapter().q40(writer, customScalarAdapters, value.r6v_1);
        writer.l4d('date');
        KotlinInstantAdapter_instance.u4h(writer, customScalarAdapters, value.s6v_1);
        writer.l4d('pairs');
        list(obj(PinnedPairInput_InputAdapter_instance)).m41(writer, customScalarAdapters, value.t6v_1);
        var tmp = value.u6v_1;
        if (tmp instanceof Present()) {
          writer.l4d('discordMessageId');
          present(get_NullableStringAdapter()).o41(writer, customScalarAdapters, value.u6v_1);
        }
        var tmp_0 = value.v6v_1;
        if (tmp_0 instanceof Present()) {
          writer.l4d('slackMessageId');
          present(get_NullableStringAdapter()).o41(writer, customScalarAdapters, value.v6v_1);
        }
      }
      q40(writer, customScalarAdapters, value) {
        return this.u6x(writer, customScalarAdapters, value instanceof SavePairAssignmentsInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePairAssignmentsInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePairAssignmentsInput_InputAdapterClass = $;
  }
  return SavePairAssignmentsInput_InputAdapterClass;
}
var SavePairAssignmentsInput_InputAdapter_instance;
function SavePairAssignmentsInput_InputAdapter_getInstance() {
  return SavePairAssignmentsInput_InputAdapter_instance;
}
//region block: init
SavePairAssignmentsInput_InputAdapter_instance = new (SavePairAssignmentsInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePairAssignmentsInput_InputAdapter_instance as SavePairAssignmentsInput_InputAdapter_instance1gft199wl28jf,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput_InputAdapter.mjs.map
